import { useRef } from "react";
import { Clue, clueClass } from "./clue";
import { LetterBindings } from "./Game";

interface KeyboardProps {
  layout: string;
  letterInfo: Map<string, [Clue, number]>;
  bindings: LetterBindings;
  letterPairStyle: string;
  letterSort: string;
  onKey: (key: string) => void;
  juiceGreen?: boolean;
  onJuiceDone?: () => void;
}

function stylize(label: string, style: string, sort: string): string {
  if(sort === "ZA") {
    return stylize(label.split("").reverse().join(""), style, "AZ")
  }
  if (style === "AZ") {
    return label[0].toUpperCase() + label[1].toUpperCase();
  }
  if (style === "az") {
    return label[0].toLowerCase() + label[1].toLowerCase();
  }
  if (style === "Az") {
    return label[0].toUpperCase() + label[1].toLowerCase();
  }
  if (style === "aZ") {
    return label[0].toLowerCase() + label[1].toUpperCase();
  }
  return label;
}

export function Keyboard(props: KeyboardProps) {
  const keyboard = props.layout
    .split("-")
    .map((row) =>
      row
        .split("")
        .map((key) => key
          .replace("B", "Backspace")
          .replace("E", "Enter")
          .replace("S", "Style")
          .replace("D","Delete")
          .replace("L","ArrowLeft")
          .replace("R","ArrowRight")
          .replace("_","SpaceBar")
          .replace("Z", "Sort"))
    );

  let bindings = props.bindings.sort(
    (a, b) => props.letterSort === "AZ" ? a[0].localeCompare(b[0]) : a[1].localeCompare(b[1])
  );

  // Count total green keys for stagger indexing
  let totalGreenKeys = 0;
  if (props.juiceGreen) {
    let bc = 0;
    keyboard.forEach(row => row.forEach(rawLabel => {
      if (rawLabel === 'x') {
        const pair = bindings[bc++];
        const info = props.letterInfo.get(pair?.toLowerCase());
        if (info && info[0] === Clue.Correct) totalGreenKeys++;
      }
    }));
  }

  const juiceDoneFired = useRef(false);
  let greenIndex = 0;
  var c = 0;
  return (
    <div className="Game-keyboard" aria-hidden="true">
      {keyboard.map((row, i) => (
        <div key={i} className="Game-keyboard-row">
          {row.map((label, j) => {
            let className = "Game-keyboard-button";
            let typedKey = label;
            if (label === 'x') {
              label = bindings[c];
              c++;
              typedKey = label[0].toLowerCase();
              className += " Letter-pair";
              const clue = props.letterInfo.get(label.toLowerCase());
              if (clue !== undefined) {
                className += " " + clueClass(clue);
              }
              const isGreenKey = clue !== undefined && clue[0] === Clue.Correct;
              const isLastGreen = isGreenKey && props.juiceGreen && greenIndex === totalGreenKeys - 1;
              if (props.juiceGreen && isGreenKey) {
                className += " keyboard-juice-green";
              }
              const style = (props.juiceGreen && isGreenKey)
                ? { "--juice-i": greenIndex++ } as React.CSSProperties
                : undefined;
              label = stylize(label, props.letterPairStyle, props.letterSort);
              return (
                <button
                  tabIndex={-1}
                  key={j}
                  className={className}
                  style={style}
                  onAnimationEnd={isLastGreen ? () => {
                    if (!juiceDoneFired.current) {
                      juiceDoneFired.current = true;
                      props.onJuiceDone?.();
                    }
                  } : undefined}
                  onClick={() => {
                    props.onKey(typedKey);
                  }}
                >
                  {label}
                </button>
              );
            } else {
              className += " Functional-key";
              label = label
                .replace("Backspace", "⌫")
                .replace("Style", "⇧")
                .replace("Sort", "⇄")
                .replace("SpaceBar", "  ")
                .replace("Delete", "Del")
                .replace("ArrowLeft", "←")
                .replace("ArrowRight", "→");
            }
            return (
              <button
                tabIndex={-1}
                key={j}
                className={className}
                onClick={() => {
                  props.onKey(typedKey);
                }}
              >
                {label}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
